import Swiper from 'swiper';

const createCardCarousel = (el) => {
    const container = el.querySelector('.card-carousel__container');
    let carousel;

    const attachNavigation = () => {
        const prevButton = el.querySelector('.card-carousel__prev');
        const nextButton = el.querySelector('.card-carousel__next');

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                carousel.slidePrev();
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                carousel.slideNext();
            });
        }
    };

    const init = () => {
        const items = container.querySelectorAll('.card-carousel__item');
        const itemCount = items.length;

        const getMaxSlidesPerView = (breakpoint) => {
            let defaultSlides;
            switch (breakpoint) {
                case 320:
                    defaultSlides = 1.2;
                    break;
                case 640:
                    defaultSlides = 2.2;
                    break;
                case 1024:
                    defaultSlides = 3.2;
                    break;
                case 1440:
                    defaultSlides = 4.2;
                    break;
                default:
                    defaultSlides = 1.2;
            }

            if (itemCount <= Math.floor(defaultSlides)) {
                return itemCount;
            }

            return defaultSlides;
        };

        carousel = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: false,
            scrollbar: {
                el: el.querySelector('.card-carousel__scrollbar'),
                draggable: true,
                dragClass: 'card-carousel__scrollbar-drag'
            },
            breakpoints: {
                320: {
                    slidesPerView: getMaxSlidesPerView(320)
                },
                640: {
                    slidesPerView: getMaxSlidesPerView(640)
                },
                1024: {
                    slidesPerView: getMaxSlidesPerView(1024)
                },
                1440: {
                    slidesPerView: getMaxSlidesPerView(1440)
                }
            }
        });

        attachNavigation();
    };

    // Initialize
    init();
};

export default createCardCarousel;
